module.exports = __webpack_public_path__ + "img/ove.6c0d2693.png";